import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FlexBox, FlexItem } from "@/components/common";
import { ExternalLinks } from "@/components/account/display";
import {
  ApiKeysSettings,
  IntegrationsAccounts,
  DeleteAccount,
  UpdatePassword,
  ThemeController,
  LogOut,
} from "@/components/account/save";

/**
 * Displays information about the current user.
 */
const __default__ = {
  name: "MyAccount",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), { justify: "center" }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexItem), {
        parts: "12",
        class: "q-mr-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(LogOut)),
          _createVNode(_unref(IntegrationsAccounts)),
          _createVNode(_unref(ApiKeysSettings)),
          _createVNode(_unref(ThemeController)),
          _createVNode(_unref(UpdatePassword)),
          _createVNode(_unref(DeleteAccount)),
          _createVNode(_unref(ExternalLinks))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})